import { Component, ViewChild, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';

import { LotModel } from '@libs/portal-common/services';
import { Address } from '../Address';
import { GOOGLE_TIMEZONE_LIST, IGoogleTimeZone } from './google-timezones.dictionary';
import { GooglePlacesAutocompleteDirective } from '../google-places-autocomplete.directive';

@Component({
  selector: 'app-location-address',
  templateUrl: './location-address.component.html',
  styleUrls: ['./location-address.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class LocationAddressComponent implements AfterViewInit {
  @ViewChild('placesWrapper', { static: true }) places!: GooglePlacesAutocompleteDirective;
  addressGoogleInputValue: string;

  private _editable = true;
  @Input('editable')
  get editable(): boolean {
    return this._editable;
  }
  set editable(val: boolean) {
    this._editable = val;
    this.disableAddressParts();
  }

  private _model: LotModel;
  public _validate = false;
  public streetDisabled = false;
  public cityDisabled = false;
  public stateDisabled = false;
  public zipDisabled = false;

  @Input('model')
  get model(): LotModel {
    return this._model;
  }
  set model(val: LotModel) {
    this._model = val;
    this.resetAutocompleteValue(this.addressString(val));
    this.disableAddressParts();
  }

  @Input() set validate(flag: boolean) {
    this._validate = flag;
    if (!this.addressGoogleInputValue && this.places) {
      this.resetAutocompleteValue(this.addressString(this.model));
    }
  }

  @Input() newLocationMode = false;

  @Output() addressChanged = new EventEmitter<Address>();
  @Output() timezoneIdChanged = new EventEmitter<string>();
  @Output() addressGoogleInputIsEmpty = new EventEmitter<boolean>();

  ngAfterViewInit() {
    this.resetAutocompleteValue(this.addressString(this._model));

  }

  addressGoogleInputChange(event: any) {
    if (event && event?.target) {
      this.addressGoogleInputValue = event.target.value;
      if (event.target.value.length === 0) {
        this.addressGoogleInputIsEmpty.emit(true);
      } else {
        this.addressGoogleInputIsEmpty.emit(false);
      }
    }
  }

  public onPlaceChange(address: Address) {
    if (address) {
      this.model.City = address.city;
      this.model.Street = address.street;
      this.model.UState = address.state;
      this.model.Zip = address.zip;

      this.addressChanged.emit(address);

      if (address.timeZoneId) {
        const currentTimeZone = GOOGLE_TIMEZONE_LIST.find((tm: IGoogleTimeZone) => tm.TimeZoneId === address.timeZoneId);
        if (currentTimeZone) {
          this.timezoneIdChanged.emit(currentTimeZone.TimeZoneIdAdaptive);
        }
      }

      this.disableAddressParts();
    }
  }

  private addressString(model: LotModel): string {
    if (!model) {
      return null;
    }

    const addrParts = [model.Street, model.City, model.UState, model.Zip];

    return addrParts.filter((x) => !!x && x.trim() !== '').join(', ');
  }

  private disableAddressParts() {
    if (!this.model) {
      return;
    }

    if (this.newLocationMode) {
      this.streetDisabled = !!this.model.Street;
      this.stateDisabled = !!this.model.UState;
      this.cityDisabled = !!this.model.City;
      this.zipDisabled = !!this.model.Zip;
    } else {
      this.streetDisabled = !this.editable || !!this.model.Street;
      this.stateDisabled = !this.editable || !!this.model.UState;
      this.cityDisabled = !this.editable || !!this.model.City;
      this.zipDisabled = !this.editable || !!this.model.Zip;
    }
  }

  private resetAutocompleteValue(value: string) {
    if (this.places && value) {
      setTimeout(() => {
        this.places.setValue(value);
        this.addressGoogleInputValue = value;
      }, 200);
    }
  }
}
